export function buildExportUrl(baseUrl, filters = {}, exportFilters = {}) {
  const params = [];

  if (filters.device) params.push(`device=${filters.device}`);
  if (filters.status) params.push(`status=${filters.status}`);
  if (filters.user) params.push(`user=${filters.user}`);

  if (exportFilters.startDate) params.push(`startDate=${exportFilters.startDate}`);
  if (exportFilters.endDate) params.push(`endDate=${exportFilters.endDate}`);
  if (exportFilters.groupId) params.push(`groupId=${exportFilters.groupId}`);

  return params.length ? `${baseUrl}?${params.join('&')}` : baseUrl;
}

export function validateExportFilters(exportFilters = {}) {
  const { startDate, endDate } = exportFilters;
  if (startDate && endDate && startDate > endDate) {
    return 'La date de début doit être antérieure ou égale à la date de fin.';
  }
  return null;
}
